// extracted by mini-css-extract-plugin
export default {"logotype":"Logotype_logotype__zqqah","inner":"Logotype_inner__MHeiE","visa":"Logotype_visa__xeEuN","mir":"Logotype_mir__abQBP"};